import React from 'react';
import './App.css';
import Home from './Home';
import Header from './Header';
import Footer from './Footer';
import { BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";
import SearchPage from './SearchPage';

function App() {
  return (
    
    <div className="App">
    <Router> 
    <Header />
    

<Switch>
    
    {/* /Search */}
    <Route path="/Search">
    <SearchPage />
    </Route>

    <Route path="/">  
    <Home />
    </Route>
</Switch>    

<Footer />
    </Router>
    {/*Home*/}
      
      {/*Header*/}

      {/*Banner*/}
         {/*Search*/}

      {/*Cards*/}

      {/*Footer*/}

    {/*SearchPage*/}
      {/*...*/}
    </div>
  );
}

export default App;
